<template>
  <base-modal class="edit-group-class" title="Edit" @close="$emit('close')" data-test-id="edit-biography-modal">
    <form class="edit-group-class__form" @submit.prevent="save" data-test-id="edit-biography-form">
      <form-control label="BIOGRAPHY" theme="dark" required data-test-id="extended-biography-section">
        <text-area
          id="extended-biography-input"
          v-model="model.profile_info_extended"
          theme="dark"
          required
          data-test-id="extended-biography-input"
        ></text-area>
      </form-control>

      <div class="edit-group-class__submit">
        <p v-if="errors.length" data-test-id="error-message">{{ errors }}</p>
        <voxy-button
          view="primary"
          type="submit"
          size="s"
          :disabled="$v.model.$invalid || isSaving"
          data-test-id="submit-button"
        >
          {{ isSaving ? 'Saving...' : 'Save' }}
        </voxy-button>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { VoxyButton } from '@voxy-team/vue-voxy';
import { required } from 'vuelidate/lib/validators';

import FormErrorMapper from '@/mixins/FormErrorMapper';

import BaseModal from '@/components/BaseModal';
import FormControl from '@/components/form/FormControl';
import TextArea from '@/components/form/TextArea';

export default {
  name: 'ModalTeacherProfileInfo',

  components: {
    BaseModal,
    FormControl,
    TextArea,
    VoxyButton,
  },

  mixins: [FormErrorMapper],

  props: {
    teacherProfile: {
      default: () => ({}),
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      errors: {},
      model: {
        profile_info_extended: this.teacherProfile.profile_info_extended,
      },
      isSaving: false,
      hasError: false,
    };
  },

  validations: {
    model: {
      profile_info_extended: {
        required,
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      updateTeacherProfile: 'UPDATE_TEACHER_PROFILE',
    }),

    async save() {
      this.errors = {};

      try {
        await this.updateTeacherProfile({
          teacherHashEmail: this.$route.params.teacherHashEmail,
          value: this.model,
        });
        this.$emit('close');
      } catch (errors) {
        this.errors = JSON.stringify(errors);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/components/teacher-management-sections';
</style>
